// extracted by mini-css-extract-plugin
export var clickBlocker = "_ff-c";
export var interactivePassthrough = "_ff-4";
export var lookHere = "_ff-3";
export var modal = "_ff-e";
export var modalBackdrop = "_ff-d";
export var modalBody = "_ff-p";
export var modalBodyHero = "_ff-q";
export var modalDescription = "_ff-s";
export var modalEnter = "_ff-f";
export var modalFooter = "_ff-t";
export var modalFooterHero = "_ff-u";
export var modalHeaderText = "_ff-n";
export var modalHeroImage = "_ff-i";
export var modalHeroTitle = "_ff-l";
export var modalIconCircle = "_ff-o";
export var modalIconHeader = "_ff-m";
export var modalImageLabel = "_ff-k";
export var modalImageOverlay = "_ff-j";
export var modalImageWrapper = "_ff-h";
export var modalTitle = "_ff-r";
export var modalWithHero = "_ff-g";
export var pulse = "_ff-1";
export var pulseBorder = "_ff-2";
export var spotlight = "_ff-0";
export var tooltip = "_ff-5";
export var tooltipButtons = "_ff-a";
export var tooltipDescription = "_ff-7";
export var tooltipFooter = "_ff-8";
export var tooltipInteractiveHint = "_ff-b";
export var tooltipStepIndicator = "_ff-9";
export var tooltipTitle = "_ff-6";